const FREQ_MONTHS = { Annual: 12, 'Semi-Annual': 6, Quarterly: 3 };

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Next review = Last Review Date + Review Frequency.
export const getNextReviewDate = (policy) => {
  if (!policy?.review_date) return null;
  const [y, m, d] = policy.review_date.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1 + (FREQ_MONTHS[policy.review_frequency] || 12), d);
};

export const getReviewInfo = (policy) => {
  const next = getNextReviewDate(policy);
  if (!next) return null;
  const days = Math.ceil((next - new Date(new Date().toDateString())) / 86400000);
  if (days < 0) return { status: 'Overdue', key: 'overdue', days: Math.abs(days), next };
  if (days <= 30) return { status: 'Due Soon', key: 'due_soon', days, next };
  return { status: 'Current', key: 'current', days, next };
};
